import { PrimaryButton } from '@cb/apricot-react'
import { formatDateTime, DATETIME_FORMATS } from '@myap/ui-library'
import ModalHeader from '../_common/apricot/ModalHeader'
import ModalFooter from '../_common/apricot/ModalFooter'

function CloseButton({ clickAction }) {
  return (
    <PrimaryButton small onClick={clickAction}>
      Close
    </PrimaryButton>
  )
}

function ScoreSendOptOutCompleted({ setShouldCloseModal, diSelectionEndDate }) {
  const handleClick = () => setShouldCloseModal(true)

  return (
    <>
      <ModalHeader
        isDismissable={false}
        title="Confirm You Don’t Want to Choose a Free Score Send Recipient"
      />
      <div className="cb-modal-content">
        <p>
          You have confirmed you are not selecting a recipient for your score report at this time.
          If you change your mind, you can go to the Free Score Sends page prior to{' '}
          <strong>{formatDateTime(diSelectionEndDate, DATETIME_FORMATS.longMonthDayYear)}</strong>{' '}
          to select your recipient.
        </p>
      </div>
      <ModalFooter actions={[() => CloseButton({ clickAction: handleClick })]} />
    </>
  )
}

export default ScoreSendOptOutCompleted
